import type {Expand} from '../../../api/types';
import type {BaseConfig, Batch} from './types';

export function makeExpandFromBatchConfig<
  Config extends BaseConfig<any> = BaseConfig<any>,
>(config: Batch<Config>): Expand | Expand[] {
  return config.params.map(entry => entry.expand ?? {});
}
